import React, { useEffect } from 'react';
import { MainLayout } from '@design-system/Layout';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderHistory } from './redux/selectors';
import { get_orders } from './redux/reducer';
import { Container, LinkRoute } from './style';
import Summary from './components/summary';
import DeliveryAddress from './components/deliveryAddress';
import CustomerDetails from './components/customerDetails';
import SellaInformation from './components/sellaInformation';
import { Link } from 'react-router-dom';

const OrderHistory = () => {
  const params = useParams();
  const orders = useSelector(getOrderHistory);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(get_orders(params.id));
  }, [dispatch, params]);

  return (
    <MainLayout>
      <LinkRoute>
        <Link to="/settings/transactions" style={{ textDecoration: 'none' }}>
          Back
        </Link>
      </LinkRoute>
      <Container>
        <div className="left">
          <DeliveryAddress order={orders} />
          <SellaInformation order={orders} />
          <CustomerDetails order={orders} />
        </div>
        <div className="right">
          <Summary order={orders} />
        </div>
      </Container>
    </MainLayout>
  );
};

export default OrderHistory;
